module.exports = "<i class=\"icon {{iconname}}\"> </i>";